module.exports = __webpack_public_path__ + "/img/693afaf40e60af3de7e739c3f3ca3849.png";